import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';

/**
 *  This component uses css borders to display a ribbon offset to the right or left and uses uiContext to
 *  dictate which background colors will be used.
 */
import { jsx as _jsx } from "react/jsx-runtime";
function Ribbon(_ref) {
  let {
    label,
    position = 'right',
    className,
    uiContext = null,
    newClass,
    ...rest
  } = _ref;
  const context = uiContext;
  const ribbonClasses = clsx({
    ribbon: true,
    'text-bold': uiContext !== 'payment',
    [`${position}`]: true,
    [`ribbon-${context}`]: context
  }, className);
  return /*#__PURE__*/_jsx("div", {
    className: ribbonClasses,
    ...rest,
    children: /*#__PURE__*/_jsx("div", {
      className: `ribbon-content-${position}`,
      children: label
    })
  });
}
export default Ribbon;